var map = {
	"./bg/global": 256,
	"./bg/global.gif": 256,
	"./bg/tracking8": 257,
	"./bg/tracking8.jpg": 257,
	"./logo": 258,
	"./logo-s": 259,
	"./logo-s.png": 259,
	"./logo.png": 258,
	"./logo/dhl": 260,
	"./logo/dhl.gif": 260,
	"./logo/fedex": 261,
	"./logo/fedex.gif": 261,
	"./logo/fwx": 262,
	"./logo/fwx.png": 262,
	"./logo/sf": 263,
	"./logo/sf.gif": 263,
	"./logo/sto": 264,
	"./logo/sto.gif": 264,
	"./logo/ups": 265,
	"./logo/ups.gif": 265,
	"./logo/usps": 266,
	"./logo/usps.gif": 266,
	"./logo/yto": 267,
	"./logo/yto.gif": 267,
	"./logo/yunda": 268,
	"./logo/yunda.gif": 268,
	"./service": 269,
	"./service.jpg": 269,
	"./services/01": 270,
	"./services/01.jpg": 270,
	"./services/02": 271,
	"./services/02.jpg": 271,
	"./services/03": 272,
	"./services/03.jpg": 272,
	"./services/04": 273,
	"./services/04.jpg": 273,
	"./services/05": 274,
	"./services/05.jpg": 274,
	"./services/06": 217,
	"./services/06.jpg": 291,
	"./services/06.png": 217,
	"./services/07": 275,
	"./services/07.jpg": 275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;